import { gql } from "@apollo/client";

export const BANNER_BASIC_FRAGMENT = gql`
  fragment BannerBasic on Banner {
    id
    title
    image
    imageMd
    imageSm
    url
    activeFrom
    activeUntil
    showButton
    contentPosition
    bannerType
    buttonColor
    buttonText
  }
`;
